import React, { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../tailwind/molecules/Tabs";
import MailerCard from "./MailerCard";
import { useHistory } from "react-router-dom";
import { PopUpModals, TestMailModal } from "../../modals";
import { companyMailerApi } from "../../../services";
import { EMAIL_REGEX } from "../../../constants/companyMailer";
import { handleAppError } from "../../handlers";
import { successOrFailureToaster } from "../../common/atoms/messages";
import { file, review_mailer } from "../../../assets/images";


const MailerPanel = ({ setPageLoading, selectedBenefit, fetchMailers }) => {
  const history = useHistory();
  const [activeGrade, setActiveGrade] = useState(selectedBenefit?.id || null);
  const [test, setTest] = useState({mail: '', testMail: false, data: {}});
  const [sendModal, setSendModal] = useState({send: false, type: '', launch: false, launchSent: false, employee_count: {base: 0}, activate: 0, disable: false})
  const [cloneModal, setCloneModal] = useState({dataId: 0, open: false, data: {}});
  
  
  useEffect(() => {
    setActiveGrade(selectedBenefit?.id)
  }, [selectedBenefit]);

  const getData = (e) => {
    let event = e.target !== undefined ? e.target.name : e
    let data = {}
    let allBenefits = flattenBenefits(selectedBenefit);
    data = allBenefits.find(item => `${item.grade}-${item.id}` === event);
    return(data);
  }

  function flattenBenefits(benefit, maxDepth = 3, currentDepth = 0) {
    if (!benefit || currentDepth >= maxDepth) return [];
  
    const children = benefit.grade_variants || [];
  
    return [
      benefit,
      ...children.flatMap(child => flattenBenefits(child, maxDepth, currentDepth + 1))
    ];
  }

  const onEdit = (e) => {
    let data = getData(e);
    history.push({
        pathname: '/mail-setup',
        state: { title: e.target.name,
                 id: data?.id,
                 backPath: '/benefit-adoption-mailers',
                count: 0}
    })
  }

  const sentTestMail = (e) => {
    let data = getData(e);
    let subState = {testMail: true, data: data}
    setTest((prev) => {
      return{...prev,...subState}
    })
  }

  const testMailFunc = () => {
    let data = test.testMail;
    let subState = {testMail: !data}
    setTest((prevValues) => {
      return{...prevValues,...subState}
    });
  }

  const handleValidation = (email) => {
    let errors = {};
    let formIsValid = true
    email.split(',').map((mail) => {
    if (!mail.trim().match(EMAIL_REGEX)){
      errors["email"] = "Not a valid email"
      formIsValid = false
    }
    })
    return formIsValid
  }

  const sendTest = () => {
    if(handleValidation(test.mail)){
      test.mail.split(',').map((mail) => {
      const options = { id: test.data.id, data: {...test.data, email: mail.trim()} }

      companyMailerApi.test_mail(
        options,
        (res) => {
          if(res.data.message === "success"){
            let message = `Test email sent successfully to: ${test.mail.replace(',',', ')}`
            successOrFailureToaster({ message, type: 'success'})
            setTest((prev) => { return {...prev,...{testMail: false}}})
          }else{
            successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
          }
        },
        (err) => handleAppError(err)
      )
    })
    }else{
      alert('Not a valid email address.')
    }
  }

  const showPreview = (e) => {
    let data = getData(e);
    history.push({
      pathname: '/mail-config',
      state: {id: data.id,
              show: true}
    })
  }

  const sendMailNowOrLater = (e) => {
    let event = e.target !== undefined ? e.target.name : e
    let subState = {}
    subState = {send: !sendModal.send, type: event || ''}
    setSendModal((prev) => {
      return{...prev,...subState}
    });
  }

  const closeSendModal = () => {
    let subState = {launch: false, send: false}
    setSendModal((prev) => {
      return{...prev,...subState}
    })
    sessionStorage.setItem('popUp','stop');
  }

  if (!selectedBenefit) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-10 text-center shadow-md animate-fade-in">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
          </div>
          <h3 className="text-2xl font-medium mb-3 text-gray-700">Select a Benefit</h3>
          <p className="text-gray-500 max-w-md mx-auto">Choose a benefit option from the dropdown above to view available mailers.</p>
        </div>
      </div>
    );
  }

  const tiggerMail = () => {
    let type = sendModal.type;
    setPageLoading(true);
    let data = getData(type)
    const options = {id: data.id, params: {launch_type: sendModal.type}};
      companyMailerApi.mailer_sender(
        options,
        (res) => {
          if(res.data.message === "success"){
            setSendModal((prev) => {return {...prev,send: false}})
            setPageLoading(false);
              let message = 'Congratulations! Your campaign was successfully created. Your campaign is queued to be sent.'
              successOrFailureToaster({ message, type: 'success'})
              fetchMailers()
              setSendModal((prev) => {return {...prev,launch: false, launchSent: true}})
          }else{
            successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
            setSendModal((prev) => {return {...prev, disable: true, send: false}})
          }
        },
        (err) => {
          if(err?.response?.data?.message === 'employee count is less than required'){
            let subState = {launch: false, launchSent: false, disable: true, send: false}
            setSendModal((prev) => {return {...prev, ...subState }})
            successOrFailureToaster({message: 'Employee count is less than required', type: 'fail'})
          }else{
            let subState = {launch: false, launchSent: false, disable: false, send: false}
            setSendModal((prev) => {return {...prev, ...subState }})
            handleAppError(err)
          }
        }
      )
    setPageLoading(false);
  }

  const onClone = (data) => {
    let subState = {open: true, dataId: data.id, data: data}
    setCloneModal((prev) => {
      return{...prev,...subState}
    })
  }

  const closeCloneModal = () => {
    let subState = {open: false, dataId: 0}
    setCloneModal((prev) => {
      return{...prev,...subState}
    })
  }

  const cloneMailer = () => {
    let data = cloneModal.data;
    setPageLoading(true);
    companyMailerApi.clone_mailer(
      {id: data.id},
      (res) => {
        if(res.data.message === "success"){
          let message = `${data.grade} Mailer cloned successfully`
          successOrFailureToaster({ message, type: 'success'})
          setCloneModal((prev) => {return {...prev,open: false}})
          fetchMailers()
        }else{
          successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
          setCloneModal((prev) => {return {...prev,open: false}})
        }
      },
      (err) => {
        successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
        setCloneModal((prev) => {return {...prev,open: false}})
      }
    )
    setTimeout(() => { setPageLoading(false);

    }, 500);
  }

  const multiGradeMailers = [selectedBenefit,...selectedBenefit?.grade_variants.filter((variant) => variant?.grade !== selectedBenefit?.grade)] || [];

  return (
    <>
      { test.testMail && 
          <TestMailModal
            title='Send a Test Email' 
            description='Send a test to' 
            onClose={testMailFunc} 
            onSave={sendTest} 
            inputVal={(val) => {setTest((prev) => {return{...prev,...{mail: val}}})}} 
          />
      }
       { sendModal.send &&
          <PopUpModals
            title={['Review ', selectedBenefit.has_grades ? sendModal.type?.split('-')?.[0] : '' , ' Mailer']}
            classes='w-1/3'
            description={["You are about to send the ",<strong className='capitalize'> {selectedBenefit.has_grades ? sendModal.type?.split('-')?.[0] : ''} mailer. </strong>,' - help your team discover their newest health perks.']}
            onCancel='Send it later'
            onPass='Send now'
            icon={review_mailer}
            onClose={closeSendModal}
            onSave={tiggerMail}
          />
        }
        { cloneModal.open &&
          <PopUpModals
            title={['Clone ', selectedBenefit.has_grades ? sendModal.type?.split('-')?.[0] : '' ,' Mailer Template']}
            classes='w-1/3'
            description={["Create a copy of ",<strong className='capitalize'> {selectedBenefit.has_grades ? sendModal.type?.split('-')?.[0] : ''} mailer. </strong>,' - to reuse its layout and content for another campaign or audience.']}
            onCancel='do not clone'
            onPass='clone'
            icon={file}
            onClose={closeCloneModal}
            onSave={cloneMailer}
          />
        }
      {selectedBenefit.has_grades && selectedBenefit?.grade_variants ? (
        <>
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-semibold text-gray-800">{selectedBenefit.benefit_name} Mailers</h2>
            <span className="bg-gray-250 text-primary px-3 py-1 rounded-full text-sm font-medium">
              Multiple Grades Available
            </span>
          </div>
          <Tabs
            defaultValue={activeGrade || undefined}
          >
            <TabsList className="mb-6 bg-gray-100 flex overflow-x-auto space-x-1">
              {multiGradeMailers.map((gradeMailer) => (
                <TabsTrigger
                  key={gradeMailer.id} 
                  value={gradeMailer.id}
                  className="data-[state=active]:bg-white data-[state=active]:shadow-sm"
                >
                  <span className='capitalize'>{`${gradeMailer.grade} Grade (${(gradeMailer?.grade_variants?.filter((variant) => variant?.grade === gradeMailer?.grade)?.length || 0) + 1})`}</span>
                </TabsTrigger>
              ))}
            </TabsList>

            {multiGradeMailers.map((gradeMailer) => (
              <TabsContent key={gradeMailer.id} value={gradeMailer.id} className="mt-2">
                <MailerCard mailerData={[gradeMailer, ...gradeMailer?.grade_variants.filter((item) => item?.grade === gradeMailer.grade)]} onSendTestMail={sentTestMail} onSendNow={sendMailNowOrLater} onPreview={showPreview} onEdit={onEdit} onClone={onClone} />
              </TabsContent>
            ))}
          </Tabs>
        </>
      ) : (
        <>
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-semibold text-gray-800">{selectedBenefit.benefit_name} Mailer</h2>
            {/* <span className="bg-gray-250 text-primary px-3 py-1 rounded-full text-sm font-medium">
              Base
            </span> */}
          </div>
          <MailerCard mailerData={[selectedBenefit,...selectedBenefit?.grade_variants]} onEdit={onEdit} onSendTestMail={sentTestMail} onSendNow={sendMailNowOrLater} onPreview={showPreview} onClone={onClone} />
        </>
      )}
    </>
  );
};

export default MailerPanel;